import { mainFetchUrl } from "../constants/urls";
import { createSearchParams, FetchFunction } from "./util";

export const createRequestToken = (fetchFunction: FetchFunction) => {
  const searchParams = createSearchParams();
  return fetchFunction(`${mainFetchUrl}/authentication/token/new?${searchParams.toString()}`);
};

export const retrieveSessionId = (fetchFunction: FetchFunction, requestToken: string) => {
  const searchParams = createSearchParams();
  searchParams.append("request_token", requestToken);
  return fetchFunction(`${mainFetchUrl}/authentication/session/new?${searchParams.toString()}`);
};

export const retrieveAccountId = (fetchFunction: FetchFunction, sessionId: string) => {
  const searchParams = createSearchParams();
  searchParams.append("session_id", sessionId);
  return fetchFunction(`${mainFetchUrl}/account?${searchParams.toString()}`);
};
